import React from 'react';
import { Formik, Field } from 'formik';
import { Grid } from '@inplayer-org/inplayer-ui';
import { object, string } from 'yup';

// utils
import JSONparse from 'utils/json-parse-safe';

// components
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import Input from 'components/Fields/Input';
import FieldError from 'components/Fields/FieldError';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

const { Container, Cell } = Grid;

const validationSchema = object().shape({
  streamURL: string().matches(
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
    'StreamURL must be a valid URL'
  ),
});
interface FormValues {
  video_id: string;
  streamURL: string;
}

const defaultValues: FormValues = {
  video_id: '',
  streamURL: '',
};

interface Props {
  rawContent: string;
  onSubmit: (contentString: string, externalAssetId: string) => void;
  formId: string;
  isReadOly: boolean;
  closePanel: () => void;
}

const SportOneContent = ({ rawContent, onSubmit, formId, isReadOly, closePanel }: Props) => {
  const initialValues: FormValues = {
    ...defaultValues,
    ...JSONparse(rawContent).value,
  };

  const handleSubmit = (data: FormValues) => {
    const contentString = JSON.stringify(data);
    const { video_id: externalAssetId } = data;

    onSubmit(contentString, externalAssetId);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues} validationSchema={validationSchema}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Container columns={1} rowGap="1rem">
              <Cell>
                <Field
                  tag="text_input_video_id"
                  name="video_id"
                  label="Video ID"
                  component={Input}
                  disabled={isReadOly}
                />
              </Cell>
              <Cell>
                <Field
                  tag="text_input_stream_url"
                  name="streamURL"
                  label="Stream URL"
                  component={Input}
                  disabled={isReadOly}
                />
                <FieldError name="streamURL" />
              </Cell>
            </Container>
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default SportOneContent;
